// extracted by mini-css-extract-plugin
export var fileUpload = "_ds-1";
export var modalButton = "_ds-0";